<template>
  <v-app class>
    <v-main>
      <div class="wrapper_product_downloader">
      <!-- <div>ciao mondo {{ prodid }}</div> -->
      <MainComponent />
      </div>
    </v-main>
  </v-app>
</template>


<script>
import MainComponent from "./../components/downloaderMainComponent.vue";
export default {
  name: "DownloadApp",
  components: {
    MainComponent,
  },
  computed: {
    prodid() {
      return this.$store.state.product.id;
    },
  },
};
</script>

<style>

#download_app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  margin-top: 0px;
  border-radius: 0px;
  background: #c5c4c1;
  max-height: 470px !important;
  max-width: 90% !important;
}

#download_wrapper #app{
  background: #c5c4c1 !important;
  max-height: 575px !important;
  max-width: 100% !important;
  align-content: center;
}


</style>

